var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4815 84.3553L49.0549 82.2604C48.2032 81.7398 47.9499 80.6188 48.4953 79.7812L51.991 74.4227C52.2637 74.0048 52.3469 73.493 52.2212 73.0096L50.507 66.4132C50.3689 65.8802 49.9899 65.4428 49.4835 65.2285L41.6334 61.9029C41.0083 61.6373 40.5886 61.0387 40.5549 60.3605L40.5 59.2768C40.4664 58.6109 40.8099 57.9823 41.3908 57.6511L46.6377 54.6549C47.0804 54.4017 47.3921 53.9714 47.4948 53.472L48.8938 46.6188C48.9469 46.3585 48.9416 46.0894 48.8761 45.8308L45.4424 32.2574C45.3928 32.0591 45.3078 31.8713 45.1945 31.7013L36.1438 18.266C35.4992 17.308 35.9277 15.9994 37.015 15.6098L39.7864 14.6146C40.6311 14.3118 41.5696 14.689 41.9698 15.4911L47.3602 26.3109C47.4718 26.5358 47.6312 26.7359 47.8277 26.8953L55.4866 33.1269C55.731 33.3252 55.9187 33.5873 56.0285 33.8812L58.7148 41.0868C58.8831 41.5366 59.2266 41.8996 59.6675 42.0926L68.2277 45.8202C68.7962 46.0681 69.4514 46.0008 69.9578 45.6431L75.1552 41.9669C75.6033 41.6499 76.1735 41.5578 76.6994 41.7207L78.6013 42.3069C79.4708 42.5743 79.9949 43.4561 79.8178 44.3469L78.3658 51.6055C78.341 51.7312 78.302 51.8552 78.2489 51.9739L75.667 57.8176C75.389 58.4462 74.7745 58.8571 74.0874 58.873L69.7754 58.9722C68.8599 58.9934 68.1126 59.7089 68.0489 60.6208L67.8559 63.4311C67.8399 63.6507 67.785 63.8668 67.6894 64.0669L62.1219 75.8358C62.1024 75.8766 62.0812 75.9173 62.0582 75.958L59.0407 81.2386C58.8919 81.499 58.6776 81.7185 58.4209 81.8744L54.3232 84.3571C53.7565 84.7006 53.0464 84.7006 52.4815 84.3553Z",
    fill: "url(#paint0_linear_2565_306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2565_306",
    x1: 40.5354,
    y1: 15.3884,
    x2: 66.6074,
    y2: 67.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#020C41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/australia.fdcd05359cb36f369655c759e53f643b.svg";
export { ForwardRef as ReactComponent };